export default "__VITE_ASSET__D_00dvow__"